const SEAT_STATUS = {
  'active': 1,
  'paused': 2,
  'unprotected': 3,
  'archived': 4,
  'unprotecting': 5,
}

const SEAT_STATUS_ACTIONS = {
  'active': 'protect',
  'paused': 'pause',
  'unprotected': 'unprotect',
}

const getEnumLabel = value => {
  return Object.keys(SEAT_STATUS).find(key => SEAT_STATUS[key] === value)
}

const getAlternativesForStatus = status => {
  switch (status) {
    case 1:
      return [2, 3];
    case 2:
      return [1, 3];
    case 3:
      return [1];
    case 4:
      return [3];
    default:
      return [];
  }
};

const getDataSetLabel = label => {
  if (label === 0) {
    return "Contact"
  } else if (label === 1) {
    return "Calendar"
  } else if (label === 2) {
    return "Mail"
  } else if (label === 3) {
    return "Drive"
  } else if (label === 4 || label === 11) {
    return "Conversations"
  } else if (label === 5) {
    return "List"
  } else if (label === 7) {
    return "Tasks"
  } else if (label === 8) {
    return "Tasks"
  } else if (label === 16) {
    return "Classroom"
  } else if (label === 17) {
    return "Announcement"
  } else if (label === 18) {
    return "People"
  } else if (label === 19) {
    return "Classwork"
  } else if (label === 20) {
    return "Grade"
  }
  return "NA"
}

const getStatus = label => {
  if (label === 'PROGRESS') {
    return "In progress"
  } else if (label === 'COMPLETED') {
    return "Completed"
  } else if (label === 'FAILED') {
    return "Failed"
  } else if (label === 'PENDING') {
    return "Pending"
  } else if (label === 'CANCELLED') {
    return "Cancelled"
  } else if (label === 'CANCELLED') {
    return "Cancelled"
  } else if (label === 'PARTIALLYSUCCEEDED') {
    return "Partially completed"
  }
  return "/"
}

const getRestoreType = restoreType => {
  if (restoreType == 2) {
    return "Skip Existing"
  } else if (restoreType == 3) {
    return "Override older"
  } else if (restoreType == 4) {
    return "Override always"
  }

  return "New Folder"
}

const getTaskStatus = status => {
  if (status === 0) {
    return "Not started"
  } else if (status === 1) {
    return "In progress"
  } else if (status === 2) {
    return "Completed"
  } else if (status === 3) {
    return "Waiting on others"
  } else if (status === 4) {
    return "Deferred"
  }
}

const getJobStatus = label => {
  if (label === 'IN_PROGRESS') {
    return "In progress"
  } else if (label === 'FINISHED') {
    return "Completed"
  } else if (label === 'FAILED') {
    return "Failed"
  } else if (label === 'STARTED') {
    return "Pending"
  } else if (label === 'CANCELED') {
    return 'Canceled'
  }
  return "/"
}

const getJobSourcetype = sourceType => {
  if (sourceType == 0) {
    return 'User'
  } else if (sourceType == 1) {
    return 'Site'
  } else if (sourceType == 2) {
    return 'Team'
  } else if (sourceType == 3) {
    return 'Shared drive'
  } else if (sourceType == 4) {
    return 'Mailbox'
  } else if (sourceType == 5) {
    return 'Team Folders'
  } else if (sourceType == 7) {
    return 'Class'
  }

  return '/'
}

const getJobEventStatus = status => {
  if (status == -1) {
    return 'Cancelled'
  } else if (status == 0) {
    return 'All'
  } else if (status == 1) {
    return 'Started'
  } else if (status == 2) {
    return 'In progress'
  } else if (status == 3) {
    return 'FINISHED'
  } else if (status == 4) {
    return 'FAILED'
  }

  return '/'
}

const getTypeName = value => {
  if (value === 0) {
    return 'All'
  }
  if (value === 1) {
    return "Backup"
  } else if (value === 2) {
    return "Restore"
  } else if (value === 3) {
    return "Export"
  } else if (value === 4) {
    return "Search"
  } else if (value === 5) {
    return "Seat"
  } else if (value === 6) {
    return "Delete"
  } else if (value === 7) {
    return "S3 Setup"
  } else if (value === 8) {
    return "Broadcast"
  } else if (value === 9) {
    return "Compare"
  } else if (value === 10) {
    return "Seeding"
  }
  return "/"
}

const getUserActivityType = value => {
  if (value === 0) {
    return 'All'
  }
  if (value === 1) {
    return "Activate all"
  } else if (value === 2) {
    return "Unprotect all"
  } else if (value === 3) {
    return "Refresh seats"
  } else if (value === 4) {
    return "Enable auto add"
  } else if (value === 5) {
    return "Disable auto add"
  } else if (value === 6) {
    return "Edit domain"
  } else if (value === 7) {
    return "Cancel export"
  } else if (value === 8) {
    return "Delete export"
  } else if (value === 9) {
    return "Create backup"
  } else if (value === 10) {
    return "Enable daily backup status notification"
  } else if (value === 11) {
    return "Disable daily backup status notification"
  } else if (value === 12) {
    return "Sign in"
  } else if (value === 13) {
    return "Edit backup actions in Seat Management"
  } else if (value === 14) {
    return "Restore (snapshot/search/selection)"
  } else if (value === 15) {
    return "Export (snapshot/selection/search)"
  } else if (value === 16) {
    return "Cancel restore"
  } else if (value === 17) {
    return "Backup all"
  } else if (value === 18) {
    return "Enable include unlicensed"
  } else if (value === 19) {
    return "Disable include unlicensed"
  } else if (value === 20) {
    return "Compare"
  } else if (value === 21) {
    return "Cancel compare"
  } else if (value === 22) {
    return "Cancel backup"
  } else if (value === 23) {
    return "Set up connection"
  } else if (value === 24) {
    return "Edit connection"
  } else if (value === 25) {
    return "Delete connection"
  } else if (value === 26) {
    return "Add recipient"
  } else if (value === 27) {
    return "Edit recipient"
  } else if (value === 28) {
    return "Delete recipient"
  }
  // else if (value === 00000) {
  //   return "Create seeding template"
  // } else if (value === 00000) {
  //   return "Enable include in backup"
  // } else if (value === 00000) {
  //   return "Disable include in backup"
  // }
  return "/"
}

const getReportingModuleName = (value, provider = 1) => {
  if (value === 1 && provider == 1) {
    return "OneDrive"
  } else if (value === 1 && (provider == 2 || provider == 3 || provider == 4)) {
    return "Drive";
  } else if (value === 2 && provider == 1) {
    return "Mail"
  } else if (value == 2 && provider == 2) {
    return "Gmail"
  } else if (value === 3) {
    return "Calendar"
  } else if (value === 4) {
    return "Contacts"
  } else if (value === 5) {
    return "Outlook"
  } else if (value === 6) {
    return "Team"
  } else if (value === 7) {
    return "SharePoint"
  } else if (value === 8 && provider == 3) {
    return "Team Folders"
  } else if (value === 8) {
    return "Shared Drives"
  } else if (value === 9) {
    return "Conversations"
  } else if (value === 10) {
    return "Tasks"
  } else if (value === 12) {
    return "Classroom"
  } else if (provider == 5) {
    return 'Salesforce'
  }
  return "NA"
}

const getBackupJobModule = (value, provider, sourceType = null) => {
  if (sourceType !== null && sourceType === 5 && provider === 3) {
    return "Team Folders"
  } else if (value === 0) {
    return "Contacts"
  } else if (value === 1) {
    return "Calendar"
  } else if (value === 2) {
    return "Gmail"
  } else if (value === 3 && provider === 1) {
    return "OneDrive"
  } else if (value === 3 && provider === 2) {
    return "Drive"
  } else if (value === 3 && provider === 3) {
    return "Drive"
  } else if (value === 3 && provider === 4) {
    return "Drive"
  } else if (value === 4) {
    return "Outlook"
  } else if (value === 5) {
    return "Team"
  } else if (value === 6) {
    return "SharePoint"
  } else if (value === 7) {
    return "List"
  } else if (value === 8 && provider === 3) {
    return "User"
  } else if (value === 8) {
    return "User"
  } else if (value === 9) {
    return "Shared drives"
  } else if (value === 10) {
    return "Tasks"
  } else if (value === 11) {
    return "Team Folders"
  } else if (value === 16) {
    return "Classroom"
  } else if (provider === 5 && value === 12) {
    return "Salesforce"
  }
  return "/"
}

const getTemplateTypes = templateType => {
  if (templateType === 1) {
    return "Nodes"
  } else if (templateType === 2) {
    return "Levels"
  }
  return "NA"
}

const getActiveStatusConnections = isActive => {
  if (isActive) {
    return "Active"
  } else if (!isActive) {
    return "Expired"
  }

  return "NA"
}

const getStatusLabels = status => {
  if (status === 0) {
    return "PENDING"
  } else if (status === 1) {
    return "PROGRES"
  } else if (status === 2) {
    return "COMPLETED"
  } else if (status === 3) {
    return "FAILED"
  } else if (status === 4) {
    return "CANCELLED"
  }
  return "NA"
}

const getExportDestinationType = value => {
  if (value === 0) {
    return "Download"
  } else if (value === 1) {
    return "AWS S3"
  } else if (value === 2) {
    return "Azure Blob"
  } else if (value === 3) {
    return "Google Drive"
  } else if (value === 4) {
    return "Microsoft OneDrive"
  } else if (value === 5) {
    return "Dropbox"
  } else if (value === 6) {
    return "Box"
  } else if (value === 7) {
    return "AWS S3 Compatible"
  } else if (value === 8) {
    return "Google Cloud Platform"
  } else if (value && value.length > 0) {
    return value
  }

  return "NA"
}

export const getTooltip = item => {
  switch (item.provider) {
    case 'AWS':
      return `Bucket name: ${item.bucketName || 'NA'}`;
    case 'AzureBlob':
      return `Container name: ${item.containerName || 'NA'}`;
    case 'Microsoft':
    case 'Google':
    case 'Box':
    case 'Dropbox':
      return `Admin email: ${item.email || 'NA'}`;
    default:
      return '';
  }
}

export const getConnectionTypes = storageDestinationType => {
  if (storageDestinationType === 1) {
    return "AWS S3"
  } else if (storageDestinationType === 2) {
    return "Azure Blob Storage"
  } else if (storageDestinationType === 3) {
    return "Google Drive"
  } else if (storageDestinationType === 4) {
    return "Microsoft OneDrive"
  } else if (storageDestinationType === 5) {
    return "Dropbox"
  } else if (storageDestinationType === 6) {
    return "Box"
  } else if (storageDestinationType === 7) {
    return "AWS S3 Compatible"
  } else if (storageDestinationType === 8) {
    return "Google Cloud Platform"
  }

  return "NA"
}

export {
  SEAT_STATUS,
  SEAT_STATUS_ACTIONS,
  getAlternativesForStatus,
  getEnumLabel,
  getDataSetLabel,
  getStatus,
  getTaskStatus,
  getJobStatus,
  getJobSourcetype,
  getJobEventStatus,
  getTypeName,
  getUserActivityType,
  getRestoreType,
  getReportingModuleName,
  getBackupJobModule,
  getTemplateTypes,
  getStatusLabels,
  getExportDestinationType,
  getActiveStatusConnections
}
